"use client";

import { Pie, PieChart, Cell } from "recharts";

import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "../ui/chart";

//Styles
import * as S from "./styles";
import { ChartPieProps } from "@/types";
import { formatCurrency } from "@/utils/formatCurrency";

export const description = "A pie chart with a label";

export const ChartPieLabel: React.FC<ChartPieProps> = ({
  chartConfig,
  chartData,
  nameKey,
  currency,
}) => {
  return (
    <S.BoxContainerChart config={chartConfig} className="mx-auto aspect-square">
      <PieChart>
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent hideLabel nameKey={nameKey} />}
        />
        <Pie
          data={chartData}
          dataKey="value"
          nameKey={nameKey}
          label={({ index }) => {
            const item = chartData[index];
            if (typeof item?.percentage === "number") {
              return `${item.percentage}%`;
            }
            const isPercent = item.isPercent;
            if (isPercent) {
              return `${item.value.toFixed(2)}%`;
            }
            if (currency) {
              return formatCurrency(Number(item.value), currency);
            }
            return item.value?.toLocaleString?.() ?? "";
          }}
          innerRadius={60}
          paddingAngle={8}
        >
          {chartData.map((entry: any, idx: number) => (
            <Cell
              key={`cell-${idx}`}
              fill={chartConfig?.[entry.name]?.color || "#3B82F6"}
            />
          ))}
        </Pie>
        <ChartLegend
          content={<ChartLegendContent nameKey={nameKey} />}
          className="-translate-y-2 flex-wrap gap-1 :basis-1/4:justify-center"
        />
      </PieChart>
    </S.BoxContainerChart>
  );
};
